import { Outlet } from 'react-router-dom'
import { Navbar } from '@/components/Navbar'
import { Footer } from '@/components/Footer'
import { DemoModal } from '@/components/DemoModal'
import { ChatWidget } from '@/components/chat/ChatWidget'

export default function Layout() {
  return (
    <main className="flex flex-col min-h-screen bg-background font-sans antialiased">
      <Navbar />
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
      <DemoModal />
      <ChatWidget />
    </main>
  )
}
